import React, { useState, forwardRef, useCallback, useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";

import { useNavigate } from "react-router-dom";

import { useSnackbar, SnackbarContent, CustomContentProps } from "notistack";

import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import errorIcon from "../../assets/Icons/alert/error.svg"

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { Box } from "@mui/material";
import useAuthFlow from "../../Hooks/use-auth-flow";

const useStyles = makeStyles(() => ({
  root: {
    "@media (min-width:600px)": {
      minWidth: "344px !important",
    },
  },
  card: {
    width: "100%",
  },
  typography: {
    color: "#000",
  },
  actionRoot: {
    padding: "8px 8px 8px 16px",
    justifyContent: "space-between",
  },
  icons: {
    marginLeft: "auto",
  },
  expand: {
    padding: "8px 8px",
    transform: "rotate(0deg)",
    color: "#000",
    transition: "all .2s",
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  paper: {
    backgroundColor: "#fff",
    padding: 16,
  },
  checkIcon: {
    fontSize: 20,
    paddingRight: 4,
  },
  button: {
    padding: 0,
    textTransform: "none",
  },
}));

const ErrorAlert = forwardRef(({ id, ...props }, ref) => {
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();
  const [expanded, setExpanded] = useState(false);

    const { triggerAuth } = useAuthFlow();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  const navigate = useNavigate();

  useEffect(() => {
    if (props.message === "jwt expired") {
   triggerAuth("signin")
    }
  }, []);

  return (
    <SnackbarContent ref={ref} className={classes.root}>
      <Card
        className={classes.card}
        style={{
   background:'#ffffffb7',
          backdropFilter: "blur(10px)",
          borderRadius:'8px 0px 8px 8px',
          display:'flex',
minHeight:'60px'
          
        }}
      >
        <Box sx={{width:'15%', bgcolor:'#ffdde4', display:'grid', placeContent:'center'}}>
<img src={errorIcon} alt="error_icon" width={20}/>
        </Box>
        <CardActions classes={{ root: classes.actionRoot }}>
     <Box>
         <Typography sx={{color:'#000', fontWeight:700}}>Error Message</Typography>
          <Typography variant="body2" sx={{ color: "#000", fontWeight:300 }}>
            {props.message === "jwt expired"
              ? "Please login again"
              : props.message}
          </Typography>
     </Box>
       
        </CardActions>

           <div className={classes.icons}>
            <IconButton
              size="small"
              className={classes.expand}
              onClick={handleDismiss}
              sx={{mr:1}}
            >
              <CloseIcon sx={{ color: "#000" }} fontSize="small" />
            </IconButton>
          </div>
      </Card>
    </SnackbarContent>
  );
});

ErrorAlert.displayName = "ErrorAlert";

export default ErrorAlert;
